import Vue from 'vue'
// 工具方法
import { nativeRedirect } from '@/utils/native_interactions/native_redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'

// 通用组件
import Tag from '@/common/widgets/good_tag'

// 自定义组件
import goodImage from './widgets/good-image'
import goodShop from './widgets/good-shop'
import baseInfo from './widgets/base-info'
import goodPrice from './widgets/good-price'
import goodTag from './widgets/good-tag'

import { GOOD_VIDEO_TYPE } from '@/utils/enum'
// eslint-disable-next-line import/no-default-export
export default Vue.extend({
  components: {
    Tag,
    goodImage,
    baseInfo,
    goodShop,
    goodPrice,
    goodTag
  },
  props: {
    type: {
      type: String,
      default: 'sole'
    },
    sku: {
      type: Object,
      default: () => ({})
    },
    skuIndex: {
      type: Number,
      default: 0
    },
    goodWidth: {
      type: Number,
      default: 96
    },
    // 热销榜序号
    sortIndex: {
      type: Number,
      default: 0
    },
    fromPage: {
      type: String,
      default: ''
    },
    reportName: {
      type: String,
      default: 'similarGoods'
    }
  },
  computed: {
    ssuInfo() {
      return this.sku.ssuInfo
    },
    skuImg() {
      return this?.sku?.skuImg
    },
    // 关于sku和ssu的规格信息
    formatInfo() {
      return this.sku?.skuFormats?.skuFormat || ''
    },
    // 是否是促销价
    hasPromote() {
      // eslint-disable-next-line camelcase
      const promoteType =
        this.sku.ssuInfo?.promotion_remind_info?.promote_type ?? []
      return (
        promoteType.includes(2) || // 普通商品2和购物车3是一个东西
        promoteType.includes(3) ||
        promoteType.includes(4) ||
        promoteType.includes(21) || // 会员价（标签展示），新增类型
        promoteType.includes(12) // 会员 目前不再使用
      )
    },
    // 是否展示划线价
    showOriginalPrice() {
      return this.hasPromote && !!this.ssuInfo?.ssuPrice?.crossedPrice
    },
    // 优惠标签【放置于商品图上】
    promoteTagPic() {
      return []
    },
    // 商品标签
    goodTags() {
      return this?.ssuInfo?.ssuTags || []
    },
    depositInfo() {
      return (
        this.ssuInfo.ssuPrice.depositInfo ||
        this.ssuInfo.ssuPrice.packagePriceMsg ||
        null
      )
    },
    stockStatus() {
      return this?.sku?.skuImg?.expectArrivedRemind || ''
    },
    isVideo() {
      return this?.sku?.skuImg?.videoFlag === GOOD_VIDEO_TYPE.NORMAL
    },
    popShortName() {
      return this?.sku?.popInfo?.shopShowName || ''
    },
    popUrl() {
      return this?.sku?.popInfo?.popUrl || ''
    },
    popTags() {
      return this?.sku?.popInfo?.popTags || []
    }
  },
  methods: {
    goDetail() {
      // 复用接口，如果不是同品页面弹出事件
      if (this.fromPage === 'similar') {
        this.$track(
          this.$trackMap.similarGoods[this.ssuInfo.traceType2],
          this.ssuInfo.traceInfo
        )
      } else {
        this.$emit('beforeGoDetail')
      }

      // 跳商品详情拼接tickReferId
      const spm =
        this.$trackMap[this.reportName][this.ssuInfo?.traceType2] +
          '.' +
          this.ssuInfo?.traceInfo?.sku_pos || '0.0.0.0'

      nativeRedirect(nativeRoutes.goodsDetail, {
        id: this.ssuInfo.ssuId,
        tickReferId: spm
      })
    },
    beforeAddGoods() {
      this.$emit('beforeAddGoods')
    },
    beforeGotoShop() {
      this.$emit('beforeGotoShop')
    }
  }
})
